<template>
    <el-container class="list-page">
        <el-header class="list-page-header">
            <h1 class="list-page-title">{{$t('client.pageTitle')}}</h1>
            <div class="list-page-search">
                <el-input prefix-icon="el-icon-search" v-model="searchContent"
                          :placeholder="$t('client.searchPlaceholder')"></el-input>
            </div>
            <el-button class="list-page-add-button" type="primary" @click.native.prevent="goAddClient">
                <i class="el-icon-plus"></i>
                <span>{{$t('client.addClient')}}</span>
            </el-button>
        </el-header>
        <el-main class="list-page-main">
            <template>
                <div class="list-table-card">
                    <el-table class="list-table" @sort-change="sortTable" v-loading="loading" :data="tableData" @row-click='handleRowHandle'>
                        <el-table-column prop="name" :label="$t('client.columnClientName')" sortable="custom" :sort-orders="['descending', 'ascending']" min-width="180">
                            <template slot="header">
                                <span class="list-sort-header" :class="{'is-active': orderName === 'name'}">
                                    {{$t('client.columnClientName')}}
                                    <svg v-if="orderName === 'name'" class="list-sort-icon is-active" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
                                        <path v-if="orderName === 'name' && orderTpe === 1" d="M8 6L12 2L16 6"/>
                                        <path v-else d="M8 18L12 22L16 18"/>
                                        <path d="M12 2V22"/>
                                    </svg>
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="clientEmail" :label="$t('client.columnEmail')" min-width="220">
                            <template slot-scope="scope">
                                <span>{{scope.row.clientEmail}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="phone" :label="$t('client.columnPhone')" min-width="160">
                            <template slot-scope="scope">
                                <span>{{scope.row.phone}}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="totalBalanceDue" :formatter="amountFormat" :label="$t('client.columnBalanceDue')" min-width="160" align="right" header-align="right">
                        </el-table-column>
                    </el-table>
                </div>
                    <!--<el-table-column label="">
                        <template slot-scope="scope">
                            <el-button size="mini" @click.stop="handleClick(scope.$index, scope.row)">statement</el-button>
                        </template>
                    </el-table-column>-->
                <div class="list-pagination">
                    <el-pagination
                            @size-change="changeTotalCount"
                            @current-change="changePage"
                            :current-page="currentPage"
                            :page-sizes="[50, 100, 200, 400]"
                            :page-size="pageSize"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCount">
                    </el-pagination>
                </div>
            </template>


        </el-main>
    </el-container>
</template>

<script>
    import {debounce} from '@/utils/debounce'
    import {xiaoshudianfenge} from '@/utils/moneyFormat'
    import {readListPagination, writeListPagination} from '@/utils/listPagination'

    export default {
        methods: {
            restoreListPagination() {
                const pagination = readListPagination('client');
                if (pagination != null) {
                    this.currentPage = pagination.currentPage;
                    this.pageSize = pagination.pageSize;
                }
            },
            saveListPagination() {
                writeListPagination('client', this.currentPage, this.pageSize);
            },
            goAddClient() {
                let self = this;
                self.$router.push('/clientCreate');
            },
            queryList() {
                this.loading = true;
                let that = this;
                this.$axios.post('query_user_client_user_web', {
                    params: {
                        "currentPage": that.currentPage,
                        "pageSize": that.pageSize,
                        "userWebCommonQuery": that.searchContent,
                        "orderName": that.orderName,
                        "orderTpe": that.orderTpe,
                        "delStatus": 0
                    }
                }).then(response => {
                    if (response.data.errorCode === 0) {
                        that.tableData = response.data.dataList;
                        that.totalCount = response.data.totalCount;
                    }
                    this.loading = false;
                })
            },
            sortTable(column) {
                if (!column.order) {
                    this.orderName = "";
                    this.orderTpe = "";
                    this.queryList();
                    return;
                }
                this.orderName = column.prop;
                if (column.order === "ascending") {
                    this.orderTpe = 1
                } else if (column.order === "descending") {
                    this.orderTpe = 2
                }
                this.queryList();
            },
            changePage(val) {
                this.currentPage = val;
                this.saveListPagination();
                this.queryList();
            },
            changeTotalCount(val) {
                this.pageSize = val;
                this.saveListPagination();
                this.queryList();
            },
            handleRowHandle(row, event, column) {
                //点击每一条列表数据触发的方法
                if (column.className === "el-table-column--selection") {
                    return false;
                } else {
                    //因为需要考虑详情里面的刷新 所以把拿过去的信息放在缓存里面
                    this.$router.push({path: 'clientUpdate', query: {innerUUID: row.innerUUID}});
                }
            },
            amountFormat: function (row, column) {
                return xiaoshudianfenge(row[column.property], this.userSetting);
            },
        },
        data() {
            return {
                tableData: [],
                loading: true,
                currentPage: 1,
                totalCount: 0,
                pageSize: 50,
                searchContent: "",
                orderName: "createDate",
                orderTpe: 2,
                userSetting: {}
            }
        },
        mounted() {
            this.userSetting = JSON.parse(localStorage.getItem('userSetting')) || {};
            this.restoreListPagination();
            this.queryList();
            this.$watch('searchContent', debounce(() => {
                this.queryList();
            }, 500))
        }
    }
</script>
